import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/imgs/DigitalContacts-logo.svg';
import { findAccount } from '../actions/resetPassword';

const FindAccount = () => {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const result = await findAccount(identifier);
    setLoading(false);
    if (result.ok) {
      setMaskedEmail(result.maskedEmail);
    } else {
      setError(result.msg);
    }
  };

  return (
    <div class='my-name create-account wel-back'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='logo'>
              <Link to='/login'>
                <img src={logo} alt='logo' />
              </Link>
            </div>

            {maskedEmail ? (
              <>
                <h1>Account found</h1>
                <p className='p1'>This account uses {maskedEmail}.</p>

                <Link
                  to='/reset_password'
                  className='btn w-100prc'
                  style={{ display: 'block', textAlign: 'center' }}
                >
                  Continue to reset password
                </Link>
              </>
            ) : (
              <form id='findAccount' onSubmit={handleSubmit}>
                <h1>Find your account</h1>
                <p className='p1'>
                  Enter your profile link, your username, or the link from
                  your card — we'll show you which email address is on file.
                </p>
                <input
                  type='text'
                  name='identifier'
                  id='identifier'
                  placeholder='e.g. digitalcontacts.info/username'
                  required
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                />
                {error && (
                  <p style={{ color: 'red', fontSize: '13px', marginTop: '8px' }}>
                    {error}
                  </p>
                )}
                <button
                  className='btn w-100prc'
                  disabled={loading}
                  id='submitBtnFindAccount'
                >
                  {loading ? 'Searching...' : 'Find account'}
                </button>
              </form>
            )}

            <Link to='/login' className='forgot'>
              Back to login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindAccount;
